import { Trans } from 'react-i18next';
export const STATUS_200 = 200;
export const STATUS_300 = 300;
export const STATUS_400 = 400;
export const DATA_LIMIT = 10;
export const RE_DIGIT = new RegExp(/^\d+$/);
// export const LIMIT_DIGIT = example.slice(0, 10)+'...'; 
export const messageActionOption = {
    like: 'like',
    disLike: 'disLike',
    save: 'save',
    unSave: 'unSave',
    translator: 'translator',
    share: 'share',
    delete: 'delete',
};
export const signUpType = {
    google: 'google',
    tamara: 'tamara',
    guest: 'guest'
};
export const paginationLimit = 20;
export const paginationStartFrom = 1;
export const Authentication = {
    REDIRECT_LOGIN: 'redirectToLogin',
    TOKEN: 'token',
    USER_INFO: 'userInfo',
    GUEST_USER: 'guestUser',
    TIME: 'getTime',
}
export const validatePhoneNumber = (phoneNumber) =>
    /^\d{10}$/.test(phoneNumber);
export const checkPassword = str => {
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return re.test(str);
};
export const emptyListText = {
    AskAnything: 'Ask Me Anything...',
    EmptyHistory: 'No data here...'

}
export const isEmpty = text => {
    return !(text.toString().trim().length > 0 && text.toString().trim() !== '0');
};
export const fontSize = {
    font17: 17,
    font19: 19,
    font20: 20,
}
export const LanguagesList = [
    { name: "American English", value: 'en' },
    { name: "Hindi", value: 'hn' },
    { name: "Arabic", value: 'ar' },
    { name: "Russian", value: 'ru' },
    { name: "Portugese", value: 'po' },
    { name: "French", value: 'fr' },
    { name: "German", value: 'hn' },
    { name: "Bengali", value: 'be' },
    { name: "Gujrati", value: 'gu' },
    { name: "Hausa", value: 'ha' },
    { name: "Indonesian", value: 'in' },
    { name: "Italian", value: 'it' },
    { name: "Japanese", value: 'ja' },
    { name: "Kannada", value: 'ma' },
    { name: "Marathi", value: 'sp' },
    { name: "Punjabi", value: 'pu' },
    { name: "Spanish", value: 'sp' },
    { name: "Swahili", value: 'sw' },
    { name: "Tamil", value: 'md' },
    { name: "Telugu", value: 'te' },
    { name: "Thai", value: 'ta' },
    { name: "Turkish", value: 'hn' },
    { name: "Urdu", value: 'ar' },
    { name: "Vietnamese", value: 'md' },

]
export const LanguageList = [
    { name: <Trans>English</Trans>, value: 'en' },
    { name: <Trans>Hindi</Trans>, value: 'hn' },
    { name: <Trans>Arabic</Trans>, value: 'ar' },
    { name: <Trans>Russian</Trans>, value: 'ru' },
    { name: <Trans>Portugese</Trans>, value: 'po' },
    { name: <Trans>French</Trans>, value: 'fr' },
    { name: <Trans>German</Trans>, value: 'hn' },
    { name: <Trans>Bengali</Trans>, value: 'be' },
    { name: <Trans>Gujrati</Trans>, value: 'gu' },
    { name: <Trans>Hausa</Trans>, value: 'ha' },
    { name: <Trans>Indonesian</Trans>, value: 'in' },
    { name: <Trans>Italian</Trans>, value: 'it' },
    { name: <Trans>Japanese</Trans>, value: 'ja' },
    { name: <Trans>Kannada</Trans>, value: 'ma' },
    { name: <Trans>Marathi</Trans>, value: 'sp' },
    { name: <Trans>Punjabi</Trans>, value: 'pu' },
    { name: <Trans>Spanish</Trans>, value: 'sp' },
    { name: <Trans>Swahili</Trans>, value: 'sw' },
    { name: <Trans>Tamil</Trans>, value: 'md' },
    { name: <Trans>Telugu</Trans>, value: 'te' },
    { name: <Trans>Thai</Trans>, value: 'ta' },
    { name: <Trans>Turkish</Trans>, value: 'hn' },
    { name: <Trans>Urdu</Trans>, value: 'ar' },
    { name: <Trans>Vietnamese</Trans>, value: 'md' },

]
export const formatAMPM = (date) => {
    // console.log(date, "dateeee")
    const date1 = new Date(date);
    var hours = date1.getHours();
    var minutes = date1.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}
export const formatNewDate = (date) => {
    const date1 = date.split("T");
    const date2 = date1[0].split("-");
    return date2[1] + "/" + date2[2] + "/" + date2[0];
}
export const formatChatDate = (date) => {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
}